import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';

const INVALID_INVITE_MESSAGE =
  'This invite link has expired or is no longer valid. Ask your administrator to resend the invitation.';

const Invite = () => {
  const { loginWithRedirect } = useAuth0();
  const [token] = useState(() => new URLSearchParams(window.location.search).get('token'));
  const [isInvalid, setIsInvalid] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    window.history.replaceState(window.history.state, document.title, `${url.pathname}${url.search}${url.hash}`);

    let isCancelled = false;

    const validateInvite = async () => {
      if (!token) {
        setIsInvalid(true);
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/invite/validate`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token }),
        });
        const result = response.ok ? await response.json() : null;

        if (!isCancelled && result?.valid === true) {
          await loginWithRedirect({
            authorizationParams: {
              invite_token: token,
            },
            appState: {
              returnTo: '/',
            },
          });
          return;
        }

        if (!isCancelled) {
          setIsInvalid(true);
        }
      } catch {
        if (!isCancelled) {
          setIsInvalid(true);
        }
      }
    };

    validateInvite();

    return () => {
      isCancelled = true;
    };
  }, [loginWithRedirect, token]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      {isInvalid ? (
        <Typography variant="h6">{INVALID_INVITE_MESSAGE}</Typography>
      ) : (
        <Box>
          <CircularProgress />
          <Typography sx={{ marginTop: '16px' }}>Checking your invite link...</Typography>
        </Box>
      )}
    </Box>
  );
};

export default Invite;
